import { CalProviderLanguagesType } from '@calcom/atoms/dist/packages/platform/atoms/cal-provider/languages';
import React, { lazy, Suspense } from 'react';
import useBookerLabels from './hooks/useBookerLabels';

const loadModule = () => import('@calcom/atoms');

export const Booker = lazy(() =>
    loadModule().then((module) => ({ default: module.Booker }))
);

const CalProvider = lazy(() =>
    loadModule().then((module) => ({ default: module.CalProvider }))
);

interface ProviderProps {
    clientId: string;
    apiUrl: string;
    language: string;
}

export function LazyBookerWrapper({
    children,
    clientId,
    apiUrl,
    language,
}: {
    children: React.ReactNode;
} & ProviderProps) {
    const { labels, labelsLoaded } = useBookerLabels(language);

    if (!labelsLoaded) {
        return null;
    }

    return (
        <Suspense>
            <CalProvider
                clientId={clientId}
                options={{ apiUrl }}
                language={language as CalProviderLanguagesType}
                labels={labels}
            >
                {children}
            </CalProvider>
        </Suspense>
    );
}
